<stx-radio-group
  [controlName]="periodTypeControlName"
  [defaultOptionValue]="sinceInceptionValue"
  [formGroup]="formGroupReference"
  [options]="periodTypes"
  layoutDirection="column"
>
</stx-radio-group>
<hr class="form-subsection-separator visibility-hidden" />
@if (periodPresetsVisible) {
<div @periodRanges class="form-element-group-column">
  <fieldset>
    <div class="display-flex align-left layout-align-baseline row-wrap-until-gt-xs">
      <legend class="form-element-label legend-inner">
        {{ 'report.filters.period.calendar_year.symbol' | translate }}
      </legend>
      <div class="checkbox-container flex-row-container">
        @for (year of calendarYears; track year) {
        <stx-checkbox [formGroup]="calendarYearsGroup" [controlName]="year.controlName" class="flex-25">
          {{ year.label }}
        </stx-checkbox>
        }
      </div>
    </div>
    <hr class="form-spaced-subsection-separator" />
  </fieldset>
  <fieldset>
    <div class="align-left align-baseline row-wrap-until-gt-xs">
      <legend class="form-element-label legend-inner">
        {{ 'report.filters.period.fiscal_year.symbol' | translate }}
      </legend>
      <div class="legend-checkbox-container flex-row-container">
        @for (year of fiscalYears; track year) {
        <stx-checkbox [formGroup]="fiscalYearsGroup" [controlName]="year.controlName" class="flex-25">
          {{ year.label }}
        </stx-checkbox>
        }
      </div>
    </div>
    <hr class="form-spaced-subsection-separator" />
  </fieldset>
  <div class="form-element-group-column">
    @for (yearQuarters of quarters; track yearQuarters) {
    <fieldset class="force-hz-spacing">
      <div class="row-wrap-until-gt-xs align-left layout-align-baseline display-flex">
        <legend class="form-element-label legend-inner">
          {{ yearQuarters.year }}
        </legend>
        <div class="checkbox-container flex-row-container form-element-group-grid-4cols">
          @for (quarter of yearQuarters.periods; track quarter) {
          <stx-checkbox [formGroup]="quartersGroup" [controlName]="quarter.controlName" class="display-block force-hz-spacing">
            {{ 'date.quarter_symbol' | translate }}{{ quarter.unitValue }}
          </stx-checkbox>
          }
        </div>
      </div>
      <hr class="form-subsection-separator visibility-hidden" />
    </fieldset>
    }
    <hr class="form-spaced-subsection-separator" />
  </div>
  <div class="form-element-group-column">
    @for (yearMonths of monthsByQuarter; track yearMonths; let isLast = $last) {
    <fieldset class="force-hz-spacing">
      <div class="flex-column-container">
        <legend class="form-element-label custom-flex-100" [style.margin-bottom]="'5px'">
          {{ yearMonths.year }}
        </legend>
        @for (monthQuarter of yearMonths.quarters.slice().reverse(); track monthQuarter) { @if (monthQuarter.months?.length > 0) {
        <div class="flex-row-container custom-flex-100 align-left layout-align-baseline" [style.margin-bottom]="'5px'">
          @for (month of monthQuarter.months; track month) {
          <div
            class="form-element-group-grid-3cols"
            [style.flex]="
              monthQuarter.months.length === 2 && (month.unitValue === '5' || month.unitValue === '8' || month.unitValue === '11')
                ? '50%'
                : '100%'
            "
          >
            <stx-checkbox [formGroup]="monthsGroup" [controlName]="month.controlName" class="force-hz-spacing">
              {{ 'date.month_names.short.' + month.unitValue | translate }}
            </stx-checkbox>
          </div>
          }
        </div>
        } }
      </div>
      <hr class="form-subsection-separator visibility-hidden" />
    </fieldset>
    }
  </div>
</div>
}
